import { useQuery } from "@tanstack/react-query";
import portalPublicService from "@/lib/services/portalPublicService";
import { REGION_ID } from "@/Constants";
import {
  MemberPrimaryAttribute,
  MemberPrimaryAttributeAsKeys,
} from "@/lib/services/types";

interface OrganizationPublicDataStore {
  isLoading: boolean;
  error: Error | null;
  organizationName?: string;
  memberPrimaryAttribute?:
    | MemberPrimaryAttribute.EMAIL
    | MemberPrimaryAttribute.MOBILE_NUMBER;
  primaryAttrAsKey:
    | MemberPrimaryAttributeAsKeys.EMAIL
    | MemberPrimaryAttributeAsKeys.MOBILE_NUMBER;
  nonPrimaryAttrAsKey:
    | MemberPrimaryAttributeAsKeys.EMAIL
    | MemberPrimaryAttributeAsKeys.MOBILE_NUMBER;
}

export const useOrganizationData = (): OrganizationPublicDataStore => {
  const { data, isLoading, error } = useQuery({
    queryKey: ["organizationconfigs"],
    queryFn: async () => {
      const publicData = await portalPublicService.getPublicData(REGION_ID);
      return publicData;
    },
    staleTime: 5 * 60 * 1000,
    retry: 3,
  });

  const memberPrimaryAttribute =
    data?.organization?.configuration?.memberPrimaryAttribute;

  const primaryAttrAsKey = memberPrimaryAttribute
    ? MemberPrimaryAttributeAsKeys[memberPrimaryAttribute]
    : MemberPrimaryAttributeAsKeys.MOBILE_NUMBER; // * If for some reason the "memberPrimaryAttribute" is "undefined", fallback to "mobileNumber".

  const nonPrimaryAttrAsKey =
    memberPrimaryAttribute === MemberPrimaryAttribute.EMAIL
      ? MemberPrimaryAttributeAsKeys.MOBILE_NUMBER
      : MemberPrimaryAttributeAsKeys.EMAIL;

  return {
    organizationName: data?.organization?.organizationName,
    memberPrimaryAttribute,
    primaryAttrAsKey,
    nonPrimaryAttrAsKey,
    isLoading,
    error,
  };
};
